module.exports = __webpack_public_path__ + "img/wix.fae99757.png";